import { useTranslation } from 'react-i18next'

import { Button, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const DeleteVisibilityCriterionModal = ({ show, onClose, onDelete, loading }) => {
  const { t } = useTranslation()

  return (
    <Modal show={show} onClose={onClose} title={t('Borrar criterio de visibilidad')} size="m">
      <Styles.Container>
        <Text type="bodyMRegular">{t('Esta acción no se podrá deshacer. ¿Quieres continuar?')}</Text>
        <Styles.ActionsContainer>
          <Button fullWidth variant="outlined" onClick={onClose} disabled={loading}>
            {t('Cancelar')}
          </Button>
          <Button fullWidth onClick={onDelete} loading={loading} disabled={loading}>
            {t('Aceptar')}
          </Button>
        </Styles.ActionsContainer>
      </Styles.Container>
    </Modal>
  )
}

export default DeleteVisibilityCriterionModal
